import type { FunctionComponent } from "react";
import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import type { videoListGridCardContent$key } from "scmp-app/queries/__generated__/videoListGridCardContent.graphql";

import { Container, DurationBadge, Header, Image, ImageContainer } from "./styles";

type Props = {
  className?: string;
  reference: videoListGridCardContent$key;
};

export const VideoListGridCard: FunctionComponent<Props> = ({ className, reference }) => {
  const data = useFragment<videoListGridCardContent$key>(
    graphql`
      fragment videoListGridCardContent on Video {
        headline
        image(filter: { type: MAIN_IMAGE }) {
          size220x137: style(filter: { style: "220x137" }) {
            url
          }
        }
        ... on Video {
          duration
        }
        ...entityLink
      }
    `,
    reference,
  );

  const imageSource = useMemo(() => data?.image?.size220x137?.url ?? "", [data]);

  return (
    <Container className={className} reference={data}>
      <ImageContainer>
        <Image $aspectRatio="3/2" src={imageSource} />
        {data.duration && <DurationBadge>{data.duration}</DurationBadge>}
      </ImageContainer>
      <Header title={data.headline ?? ""}>{data.headline}</Header>
    </Container>
  );
};
